import React from "react";
import {
	AutocompleteInput,
	FormTab,
	maxLength,
	ReferenceInput,
	required,
	SelectInput,
	TabbedForm,
	TextInput,
	usePermissions,
} from "react-admin";
import useValidatableSave from "../components/forms/useValidatableSave";
import DomainNameInput from "./inputs/DomainNameInput";
import ImageInput from "./inputs/ImageInput";
import ItemsInput from "./inputs/ItemsInput";
import ThemeSelectInput from "./inputs/ThemeSelectInput";
import Toolbar from "./Toolbar";

const Form = ({ edit = false, ...props }) => {
	const { permissions } = usePermissions();
	const save = useValidatableSave({ ...props, redirect: undefined });
	return (
		<TabbedForm {...props} toolbar={<Toolbar />} save={save}>
			<FormTab label="resources.bonus-comparators.tabs.general">
				<ReferenceInput source="bookmaker_type_id" reference="bookmaker-types">
					<SelectInput optionText="name" style={{ minWidth: 256 }} />
				</ReferenceInput>
				{permissions && permissions("admin") && (
					<ReferenceInput source="user_id" reference="users">
						<AutocompleteInput optionText="name" style={{ minWidth: 256 }} />
					</ReferenceInput>
				)}
				<DomainNameInput source="domain_name" disableHelper={!edit} fullWidth />
				<TextInput source="og_title" validate={maxLength(250)} fullWidth />
				<TextInput source="facebook_pixel" validate={maxLength(100)} />
				<TextInput source="google_analytics" validate={maxLength(100)} />
				<ImageInput source="og_image" />
				<ImageInput source="logo" />
				<ImageInput source="favicon" />
				<ThemeSelectInput source="theme" validate={required()} />
			</FormTab>
			{edit && (
				<FormTab label="resources.bonus-comparators.tabs.items">
					<ItemsInput source="items" />
				</FormTab>
			)}
		</TabbedForm>
	);
};

export default Form;
